/**
 * Created by huzhongchun on 2018/4/20.
 */
const USER_INFO_UPDATE = 'USER_INFO_UPDATE';
const USER_PAGE_INFO_UPDATE = 'USER_PAGE_INFO_UPDATE';
const ROUTER_PATH_UPDATE = 'ROUTER_PATH_UPDATE';

const CALENDAR_INFO_UPDATE = 'CALENDAR_INFO_UPDATE';
const CALENDAR_DATA_UPDATE = 'CALENDAR_DATA_UPDATE';

const WORD_LEARN_UPDATE = 'WORD_LEARN_UPDATE';

//today info
const TODAY_INFO_UPDATE = 'TODAY_INFO_UPDATE';
const COMMON_INIT_DATA_UPDATE = 'COMMON_INIT_DATA_UPDATE';

const TREE_INFO_UPDATE = 'TREE_INFO_UPDATE';

//chicken
const CHICKEN_USER_INFO_UPDATE = 'CHICKEN_USER_INFO_UPDATE';

//meditation
const MEDITATION_USER_INFO_UPDATE = 'MEDITATION_USER_INFO_UPDATE';
const MEDITATION_TODAY_UPDATE = 'MEDITATION_TODAY_UPDATE';
const MEDITATION_ITEM_ID_UPDATE = 'MEDITATION_ITEM_ID_UPDATE';

//
const READ_PLAN_USER_INFO = 'READ_PLAN_USER_INFO';
const READ_PLAN_LIST_INFO = 'READ_PLAN_LIST_INFO';

// mall
const CARD_INFO_UPDATE = 'CARD_INFO_UPDATE';

//millionaire
const MILLIONAIRE_USER_INFO_UPDATE = 'MILLIONAIRE_USER_INFO_UPDATE';

//reading
const READING_USER_INFO_UPDATE = 'READING_USER_INFO_UPDATE';
const CALENDAR_USER_LIST = 'CALENDAR_USER_LIST';


//new vitality
const NEW_VITALITY_USER_INFO_UPDATE = 'NEW_VITALITY_USER_INFO_UPDATE';
const NEW_VITALITY_GLOBAL_DATA = 'NEW_VITALITY_GLOBAL_DATA';

//training
const TRAINING_USER_INFO_UPDATE = 'TRAINING_USER_INFO_UPDATE';
const TRAINING_COMMON_INIT_UPDATE = 'TRAINING_COMMON_INIT_UPDATE';
const TRAINING_TODAY_INFO_UPDATE = 'TRAINING_TODAY_INFO_UPDATE';
const TRAINING_CALENDAR_LIST = 'TRAINING_CALENDAR_LIST';
const TRAINING_CALENDAR_SELECTED_DAY_INFO = 'TRAINING_CALENDAR_SELECTED_DAY_INFO';
const TRAINING_CALENDAR_SELECTED_DATE = 'TRAINING_CALENDAR_SELECTED_DATE';
const TRAINING_USER_CENTER_INFO_UPDATE = 'TRAINING_USER_CENTER_INFO_UPDATE';
const TRAINING_WEEK_REPORT_LIST_UPDATE = 'TRAINING_WEEK_REPORT_LIST_UPDATE';

// 晚安短信
const READING_GOODNIGHT_USER_INFO_UPDATE = 'READING_GOODNIGHT_USER_INFO_UPDATE';
const READING_GOODNIGHT_2019_UPDATE = 'READING_GOODNIGHT_2019_UPDATE';
const READING_GOODNIGHT_2020_UPDATE = 'READING_GOODNIGHT_2020_UPDATE';
const READING_GOODNIGHT_2020_UPDATE_ISWEIXIN = 'READING_GOODNIGHT_2020_UPDATE_ISWEIXIN';
const READING_GOODNIGHT_2021_UPDATE = 'READING_GOODNIGHT_2021_UPDATE';
const READING_GOODNIGHT_2021_UPDATE_ISWEIXIN = 'READING_GOODNIGHT_2021_UPDATE_ISWEIXIN';
const READING_GOODNIGHT_2021_UPDATE_SIGN_RESULT = 'READING_GOODNIGHT_2021_UPDATE_SIGN_RESULT';
const GOODHUBEI_UPDATE = 'GOODHUBEI_UPDATE';
const READING_GOODNIGHT_2022_UPDATE = 'READING_GOODNIGHT_2022_UPDATE';
const READING_GOODNIGHT_2022_UPDATE_ISWEIXIN = 'READING_GOODNIGHT_2022_UPDATE_ISWEIXIN';
const READING_GOODNIGHT_2022_UPDATE_SIGN_RESULT = 'READING_GOODNIGHT_2022_UPDATE_SIGN_RESULT';
const READING_GOODNIGHT_2022_UPDATE_MESSAGE_RESULT = 'READING_GOODNIGHT_2022_UPDATE_MESSAGE_RESULT';
//ROCKET
const ROCKET_USER_INFO_UPDATE = 'ROCKET_USER_INFO_UPDATE';
const ROCKET_ENTER_INIT = 'ROCKET_ENTER_INIT';
const ROCKET_CALENDAR_UPDATE = 'ROCKET_CALENDAR_UPDATE';
const ROCKET_USER_CENTER_UPDATE = 'ROCKET_USER_CENTER_UPDATE';
const ROCKET_TODAY_UPDATE = 'ROCKET_TODAY_UPDATE';
const ROCKET_AI_CHART_UPDATE = 'ROCKET_AI_CHART_UPDATE';
const ROCKET_PRACTICE_INIT = 'ROCKET_PRACTICE_INIT';


//American
const AMERICAN_ENTER_INIT = 'AMERICAN_ENTER_INIT';
const AMERICAN_ENTER_DYNAMIC = 'AMERICAN_ENTER_DYNAMIC';
const AMERICAN_USER_INFO_UPDATE = 'AMERICAN_USER_INFO_UPDATE';
const AMERICAN_TODAY = 'AMERICAN_TODAY';
const AMERICAN_COURSETIMETABLE = 'AMERICAN_COURSETIMETABLE';
const AMERICAN_KNOWLEDGE_GRAPH = 'AMERICAN_KNOWLEDGE_GRAPH';
const AMERICAN_KNOWLEDGE_GRAPH_LEVEL1 = 'AMERICAN_KNOWLEDGE_GRAPH_LEVEL1';
const AMERICAN_USERCENTER = 'AMERICAN_USERCENTER';
const AMERICAN_EXAM_RESULT_DATA = 'AMERICAN_EXAM_RESULT_DATA';
const AMERICAN_EXAM_RESULT_DATA_COVER = 'AMERICAN_EXAM_RESULT_DATA_COVER';

// LADY
const LADY_USER_INFO_UPDATE = 'LADY_USER_INFO_UPDATE';
const LADY_USER_PAGE_INFO_UPDATE = 'LADY_USER_PAGE_INFO_UPDATE';
const LADY_ROUTER_PATH_UPDATE = 'LADY_ROUTER_PATH_UPDATE';
const LADY_CALENDAR_INFO_UPDATE = 'LADY_CALENDAR_INFO_UPDATE';
const LADY_CALENDAR_DATA_UPDATE = 'LADY_CALENDAR_DATA_UPDATE';
const LADY_TODAY_INFO_UPDATE = 'LADY_TODAY_INFO_UPDATE';
const LADY_CALENDAR_USER_LIST = 'LADY_CALENDAR_USER_LIST';
const LADY_HOME_PAGE_UPDATE = 'LADY_HOME_PAGE_UPDATE';
const LADY_COMMON_INIT_DATA_UPDATE = 'LADY_COMMON_INIT_DATA_UPDATE';

// GIRL_SCHOOL
const GS_USERINFO_UPDATE = 'GS_USERINFO_UPDATE';
const GIRL_SCHOOL_BOOKSHELF_UPDATE = 'GIRL_SCHOOL_BOOKSHELF_UPDATE';
const GIRL_USER_CENTER_UPDATE = 'GIRL_USER_CENTER_UPDATE';
const GS_INIT_UPDATE = 'GS_INIT_UPDATE';
const GIRL_HOME_PAGE_UPDATE = 'GIRL_HOME_PAGE_UPDATE';

//KUAKUATREEHOLE

const KUAKUA_SETSHARE = "KUAKUA_SETSHARE";
const KUAKUA_SETCOMMENT = "KUAKUA_SETCOMMENT";

// WORLDSMILE
const WS_SETPIN="WS_SETPIN"
//redux-action类型
export const actionTypes = {
	USER_INFO_UPDATE,
	ROUTER_PATH_UPDATE,
	WORD_LEARN_UPDATE,
	CALENDAR_INFO_UPDATE,
	CALENDAR_DATA_UPDATE,
	TODAY_INFO_UPDATE,
	COMMON_INIT_DATA_UPDATE,
	USER_PAGE_INFO_UPDATE,
	TREE_INFO_UPDATE,
	CHICKEN_USER_INFO_UPDATE,
	MEDITATION_USER_INFO_UPDATE,
	MEDITATION_TODAY_UPDATE,
	CARD_INFO_UPDATE,
	MEDITATION_ITEM_ID_UPDATE,
	READ_PLAN_USER_INFO,
	READ_PLAN_LIST_INFO,
	MILLIONAIRE_USER_INFO_UPDATE,
	READING_USER_INFO_UPDATE,
	CALENDAR_USER_LIST,
	NEW_VITALITY_USER_INFO_UPDATE,
	NEW_VITALITY_GLOBAL_DATA,
	TRAINING_USER_INFO_UPDATE,
	TRAINING_COMMON_INIT_UPDATE,
	TRAINING_TODAY_INFO_UPDATE,
	TRAINING_CALENDAR_LIST,
	TRAINING_CALENDAR_SELECTED_DAY_INFO,
	TRAINING_CALENDAR_SELECTED_DATE,
	TRAINING_USER_CENTER_INFO_UPDATE,
	TRAINING_WEEK_REPORT_LIST_UPDATE,
	READING_GOODNIGHT_USER_INFO_UPDATE,
	READING_GOODNIGHT_2019_UPDATE,
	READING_GOODNIGHT_2020_UPDATE,
	READING_GOODNIGHT_2020_UPDATE_ISWEIXIN,
	READING_GOODNIGHT_2021_UPDATE,
	READING_GOODNIGHT_2021_UPDATE_ISWEIXIN,
	READING_GOODNIGHT_2021_UPDATE_SIGN_RESULT,
	READING_GOODNIGHT_2022_UPDATE,
	READING_GOODNIGHT_2022_UPDATE_ISWEIXIN,
	READING_GOODNIGHT_2022_UPDATE_SIGN_RESULT,
	READING_GOODNIGHT_2022_UPDATE_MESSAGE_RESULT,
	ROCKET_USER_INFO_UPDATE,
	ROCKET_ENTER_INIT,
	ROCKET_CALENDAR_UPDATE,
	ROCKET_USER_CENTER_UPDATE,
	ROCKET_TODAY_UPDATE,
	ROCKET_AI_CHART_UPDATE,
	ROCKET_PRACTICE_INIT,

	AMERICAN_ENTER_INIT,
	AMERICAN_ENTER_DYNAMIC,
	AMERICAN_USER_INFO_UPDATE,
	AMERICAN_TODAY,
	AMERICAN_COURSETIMETABLE,
	AMERICAN_KNOWLEDGE_GRAPH,
	AMERICAN_KNOWLEDGE_GRAPH_LEVEL1,
	AMERICAN_USERCENTER,
	AMERICAN_EXAM_RESULT_DATA,
	AMERICAN_EXAM_RESULT_DATA_COVER,

	LADY_USER_INFO_UPDATE,
	LADY_USER_PAGE_INFO_UPDATE,
	LADY_HOME_PAGE_UPDATE,
	LADY_ROUTER_PATH_UPDATE,
	LADY_CALENDAR_INFO_UPDATE,
	LADY_CALENDAR_DATA_UPDATE,
	LADY_TODAY_INFO_UPDATE,
	LADY_COMMON_INIT_DATA_UPDATE,
	LADY_CALENDAR_USER_LIST,

	GS_USERINFO_UPDATE,
	GIRL_SCHOOL_BOOKSHELF_UPDATE,
	GS_INIT_UPDATE,
	GIRL_USER_CENTER_UPDATE,
	GIRL_HOME_PAGE_UPDATE,

	GOODHUBEI_UPDATE,

	KUAKUA_SETSHARE,
	KUAKUA_SETCOMMENT,

	WS_SETPIN,
};



// WEBPACK FOOTER //
// ./src/constants/constants.js